export const EVENTS = {
    onboardingStarted: 'OnboardingStarted',
    onboardingStartedSubmitted: 'OnboardingStartedSubmitted',
    welcomeLoggedInScreen: 'WelcomeLoggedInScreen',
    welcomeLoggedIn: 'WelcomeLoggedIn',
    onboardingEnterEmailShown: 'OnboardingEnterEmailShown',
    onboardingEnterEmailSubmitted: 'OnboardingEnterEmailSubmitted',
    signupSuccess: 'AccountCreated',
    onboardingEnterNameShown: 'OnboardingEnterNameShown',
    onboardingEnterNameSubmitted: 'OnboardingEnterNameSubmitted',
    onboardingCheckLocationShown: 'OnboardingCheckLocation',
    onboardingCheckLocationSubmitted: "OnboardingCheckLocationSubmitted",
    onboardingPlaceAlertsShown: 'OnboardingPlaceAlertsShown',
    onboardingPlaceAlertsSubmitted: 'OnboardingPlaceAlertsSubmitted',
    onboardingArShown: 'OnboardingArShown',
    onboardingArSubmitted: 'OnboardingArSubmitted',
    onboardingFlightStatusShown: 'OnboardingFlightStatusShown',
    onboardingFlightStatusSubmitted: 'OnboardingFlightStatusSubmitted',
    onboardingSosShown: 'OnboardingSosShown',
    onboardingSosSubmitted: 'OnboardingSosSubmitted',
    onboardingRoleShown: 'OnboardingRoleShown',
    onboardingRoleSubmitted: 'OnboardingRoleSubmitted',
    onboardingDisplayPlacesShown: 'OnboardingDisplayPlacesShown',
    onboardingDisplayPlacesSubmitted: 'OnboardingDisplayPlacesSubmitted',
    onboardingAddPlacesShown: 'OnboardingAddPlacesShown',
    onboardingAddPlacesSubmitted: 'OnboardingAddPlacesSubmitted',
    onboardingPlacesShown: 'OnboardingPlacesShown',
    onboardingPlacesSubmitted: 'OnboardingPlacesSubmitted',
    onboardingCreatingProfileShown: 'onboardingCreatingProfileShown',
    onboardingPaywallShown: 'OnboardingPaywallShown',
    onboardingPaywallChosen: 'OnboardingPaywallChosen',
    phoneNumberset: 'PhoneNumberset',
    phoneNumbersubmitted: 'PhoneNumbersubmitted',
    getLocation: 'GetLocation',
    mapPaywallShown: 'MapPaywallShown',
    mapPaywallChosen: 'MapPaywallChosen',
    onboardingCheckoutShown: 'OnboardingCheckoutShown',
    subBuyTapped: 'SubBuyTapped',
    subscribed: 'PaywallSubscribed',
    subBuyClosed: 'PaywallClosed',
    cardMethodChosen: 'CardCheckoutChosen',
    paymentAnimationScreen: 'PaymentAnimationScreen',
    onboardingPaymentDecline: 'OnboardingPaymentDecline',
    onboardingDeclineTryAgain: 'OnboardingDeclineTryAgain',
    googlePlayTapped: 'GooglePlayTapped',
    appleStoreTapped: 'AppleStoreTapped',
    onboardingSuccessShown: 'OnboardingSuccessShown',
    onboardingDone: 'OnboardingDone',
};